import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import isStyledPropsValid from "utils/isStyledPropsValid";

export const StyledCircularProgress = styled(CircularProgress, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, customTheme }) => ({
  color: customTheme.textColor,
}));
